import { fromAsync } from "../../async/static/fromAsync.js";
export const unionAsync = (first, second, comparer) => {
    async function* iterator() {
        const result = [];
        for (const source of [first, second]) {
            for (const value of source) {
                let exists = false;
                for (const resultValue of result) {
                    if (await comparer(value, resultValue) === true) {
                        exists = true;
                        break;
                    }
                }
                if (exists === false) {
                    yield value;
                    result.push(value);
                }
            }
        }
    }
    return fromAsync(iterator);
};
